/**
 * Subscriber registration form validation
 * Ported from /home/zucast/www/resources/assets/js/pages/subscribe.js
 *
 * Reads window._subscriberConfig injected by Blade:
 *   {
 *     registrationForm : int,   // 0=noShow, 1=show, 2=must
 *     mustValue        : int,   // 2
 *     oldValues        : { first_name, last_name, ... },
 *     i18n             : { emailRequired, firstNameRequired, ... }
 *   }
 */

(function () {
    'use strict';

    var config = window._subscriberConfig || {};
    var registrationForm = config.registrationForm || 0;
    var MUST             = config.mustValue || 2;
    var i18n             = config.i18n || {};

    // ── Helpers ──────────────────────────────────────────────────────────────

    function safeVal(el) {
        var v = el && el.value;
        return v == null ? '' : String(v);
    }

    function clearErrors(formEl) {
        formEl.querySelectorAll('.has-error').forEach(function (el) {
            el.classList.remove('has-error');
        });
        formEl.querySelectorAll('.help-block').forEach(function (el) {
            el.parentNode.removeChild(el);
        });
    }

    function addError(fieldEl, msg) {
        var wrap = fieldEl.parentNode;
        wrap.classList.add('has-error');
        if (!wrap.querySelector('.help-block')) {
            var span = document.createElement('span');
            span.className = 'help-block';
            span.textContent = msg;
            wrap.appendChild(span);
        }
        fieldEl.focus();
        fieldEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // ── Vue instance (handles v-model bindings & canSubmit) ──────────────────

    var oldValues = config.oldValues || {};

    /* global Vue */
    window.subscriberVm = new Vue({
        el: '#main',
        data: {
            firstName:   oldValues.first_name  || '',
            lastName:    oldValues.last_name   || '',
            firmName:    oldValues.firm_name   || '',
            firmType:    oldValues.firm_type   || '',
            regionCode:  oldValues.region_code || '',
            email:       oldValues.email       || '',
            telephone:   oldValues.telephone   || '',
            role:        oldValues.role        || '',
            agreement:   oldValues.agreement   || '',
        },
        computed: {
            canSubmit: function () {
                return !!this.agreement;
            }
        }
    });

    // ── Submit button click handler ───────────────────────────────────────────

    var submitBtn = document.querySelector('button.submit');
    if (!submitBtn) return;

    // Apply highlighting based on registrationForm state
    (function applyHighlighting() {
        var form = document.querySelector('form[name="event-register"]');
        if (!form) return;

        if (registrationForm === 1) { // SHOW
            ['first_name', 'last_name', 'email'].forEach(function(name) {
                var el = form.querySelector('[name="' + name + '"]');
                if (el) el.classList.add('highlight-required');
            });
        } else if (registrationForm === MUST) { // MUST
            form.querySelectorAll('input:not([type="hidden"]), select').forEach(function(el) {
                if (el.name !== 'agreement') {
                    el.classList.add('highlight-required');
                }
            });
        }
    })();

    submitBtn.addEventListener('click', function (e) {
        e.preventDefault();

        var form = document.querySelector('form[name="event-register"]');
        clearErrors(form);

        var firstNameEl  = form.querySelector('input[name="first_name"]');
        var lastNameEl   = form.querySelector('input[name="last_name"]');
        var emailEl      = form.querySelector('input[name="email"]');
        var firmNameEl   = form.querySelector('input[name="firm_name"]');
        var firmTypeEl   = form.querySelector('select[name="firm_type"]');
        var regionCodeEl = form.querySelector('select[name="region_code"]');
        var telephoneEl  = form.querySelector('input[name="telephone"]');
        var roleEl       = form.querySelector('select[name="role"]');

        // show 模式的額外驗證
        if (registrationForm === 1) {
            if (firstNameEl && lastNameEl && emailEl) {
                var firstName = safeVal(firstNameEl);
                var lastName  = safeVal(lastNameEl);
                var email     = safeVal(emailEl);
                if ((firstName !== '' || lastName !== '') && email === '') {
                    addError(emailEl, i18n.emailRequired);
                    return;
                }
            }
        }

        // must 模式逐欄驗證
        if (registrationForm === MUST) {
            if (firstNameEl && safeVal(firstNameEl) === '') {
                addError(firstNameEl, i18n.firstNameRequired);
                return;
            }
            if (lastNameEl && safeVal(lastNameEl) === '') {
                addError(lastNameEl, i18n.lastNameRequired);
                return;
            }
            if (firmNameEl && safeVal(firmNameEl) === '') {
                addError(firmNameEl, i18n.firmNameRequired);
                return;
            }
            if (firmTypeEl && safeVal(firmTypeEl) === '') {
                addError(firmTypeEl, i18n.firmTypeRequired);
                return;
            }
            if (regionCodeEl && safeVal(regionCodeEl).length !== 2) {
                addError(regionCodeEl, i18n.regionRequired);
                return;
            }
            if (emailEl && safeVal(emailEl) === '') {
                addError(emailEl, i18n.emailRequired);
                return;
            }
            if (telephoneEl && safeVal(telephoneEl) === '') {
                addError(telephoneEl, i18n.telephoneRequired);
                return;
            }
            if (roleEl && safeVal(roleEl) === '') {
                addError(roleEl, i18n.roleRequired);
                return;
            }
        }

        form.submit();
    });
})();
